import { render, staticRenderFns } from "./CorporatePinRules.vue?vue&type=template&id=25388522&scoped=true&"
import script from "./CorporatePinRules.vue?vue&type=script&lang=js&"
export * from "./CorporatePinRules.vue?vue&type=script&lang=js&"
import style0 from "./CorporatePinRules.vue?vue&type=style&index=0&id=25388522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25388522",
  null
  
)

export default component.exports